import type { State, User } from '../../types';
import { createSelector } from '@reduxjs/toolkit';

export function getUser(state: State): User {
  if (state.user === undefined || state.user === null) return { username: '', organizations: [], key: '' };
  return state.user;
}

export const userOrganizations = createSelector(getUser, (user) => user.organizations ?? []);
